import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// UI Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

// Custom components
import { readablePhoneNumber } from "../../../utils/normalize";

export default ({ onUserAction, onSortClick }) => [
  {
    dataField: "to_vch",
    text: "Device",
    sort: true,
    formatter: (device_vch) =>
      /^[\d]{10,11}$/.test(device_vch) ? readablePhoneNumber(device_vch) : device_vch,
    onSort: (obj) => {
      onSortClick("to_vch");
    },
  },
  {
    dataField: "device_type",
    text: "Device Type",
    sort: false,
  },
  {
    dataField: "from_vch",
    text: "Short code / Caller Id",
    sort: true,
    onSort: (obj) => {
      onSortClick("from_vch");
    },
  },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, suppressionlist_record) => (
      <Fragment>
        <Link to="#" onClick={() => onUserAction("delete", suppressionlist_record)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
